import dynamic from "next/dynamic";

export const TeamMemberImage = dynamic(() => import("./component"));
